import {
  Badge,
  Button,
  Drawer,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList"; // Add this import for the filter icon
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import ClearIcon from "@mui/icons-material/Clear";

const FilterComponent = ({ filters, setFilters, onApplyFilters }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
      const savedFilters = localStorage.getItem("filters");
      const parsedFilters = savedFilters ? JSON.parse(savedFilters) : filters;
      parsedFilters.page = Number(parsedFilters.page || 0); // Ensure page is a number
      parsedFilters.pageSize = Number(parsedFilters.pageSize || 20); // Ensure pageSize is a number
      setFilters(parsedFilters);
      onApplyFilters(parsedFilters);
  },[]);

  // Save filters to localStorage whenever they change
    useEffect(() => {
      localStorage.setItem("filters", JSON.stringify(filters));
    }, [filters]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };

  const ApplyClearAll = () => {
    const clearedFilters = {
      region: "",
      search: "",
      page: 0, // Reset to the first page
      pageSize: 20, // Default page size
      order: "ASC",
    };

    setFilters(clearedFilters);
    onApplyFilters(clearedFilters);
    localStorage.removeItem("filters");
    setDrawerOpen(false); // Close the drawer after clearing filters
  };

  const isFilterActive = () => {
    // Exclude page and pageSize keys
    const filtersToCheck = { ...filters };
    delete filtersToCheck.page;
    delete filtersToCheck.pageSize;

    // Check if any filter value (other than page and pageSize) is active
    return Object.values(filtersToCheck).some((value) => value !== "");
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setFilters((prevFilters) => {
      const newFilters = {
        ...prevFilters,
        mobileNo: value === undefined ? "" : value,
      };

      // Apply the filter immediately when search text is updated
      onApplyFilters(newFilters);

      return newFilters;
    });
  };

  return (
    <>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "10px",
            
          }}
        >
          {/* Search Box */}
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            value={filters.mobileNo}
            onChange={handleSearchChange} // Trigger search on change
            sx={{ width: "300px" }}
          />

          {/* Filter Toggle Button with Badge */}
          <Badge
            color="secondary"
            variant="dot"
            invisible={!isFilterActive()}
            sx={{
              "& .MuiBadge-dot": {
                width: "10px", // Adjust badge width
                height: "10px", // Adjust badge height
                borderRadius: "50%", // Make it circular
                right: 0,
                top: "10px",
              },
            }}
          >
            <IconButton
              onClick={() => setDrawerOpen((prev) => !prev)}
              style={{
                border: "1px solid #fff", // Change border color to white for contrast
                borderRadius: "4px",
                margin: "5px",
                width: "40px", // Increased width for a more comfortable click area
                height: "40px", // Increased height for a more comfortable click area
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#097969",
                color: "#fff",
                transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
                e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#097969"; // Original color
                e.currentTarget.style.transform = "scale(1)"; // Reset scale
              }}
            >
              {drawerOpen ? <FilterListOffIcon /> : <FilterListIcon />}{" "}
              {/* Change icon based on state */}
            </IconButton>
          </Badge>
        </div>

        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)} // Close drawer on backdrop click
          sx={{
            width: 320,
            // zIndex: 1301,  // Higher zIndex than AppBar (default is 1100)
            overflowY: "auto",
            "& .MuiDrawer-paper": {
              width: 320, // Ensure Drawer paper width is fixed
              overflow: "hidden",
            },
          }} // Set width of the drawer
        >
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Filter Options
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setDrawerOpen(false)}
            >
              <ClearIcon />
            </IconButton>
          </Toolbar>

          <div
            style={{
              padding: 16,
              overflowY: "auto",
              maxHeight: "calc(100vh - 64px)",
            }}
          >
            {" "}
            {/* Added overflow and maxHeight */}
            <Grid
              container
              spacing={1}
              style={{ marginBottom: 16 }}
              direction="column"
            >
              <Grid item xs={12}>
                <TextField
                  label="Region"
                  fullWidth
                  size="small"
                  name="region"
                  value={filters.region ? filters.region : ""}
                  onChange={handleInputChange}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Order"
                  fullWidth
                  size="small"
                  name="order"
                  value={filters.order ? filters.order : ""}
                  onChange={handleInputChange}
                  select
                >
                  <MenuItem value="ASC">Ascending</MenuItem>
                  <MenuItem value="DESC">Descending</MenuItem>
                </TextField>
              </Grid>

              {/* Apply and Clear Buttons */}
              <Grid item xs={12} style={{ textAlign: "right" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    onApplyFilters(filters);
                    setDrawerOpen(false);
                  }}
                >
                  Apply Filters
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={ApplyClearAll}
                  style={{ marginLeft: 8 }}
                >
                  Clear All
                </Button>
              </Grid>
            </Grid>
          </div>
        </Drawer>
      </div>
    </>
  );
};

export default FilterComponent;
